import {
  getCurrentCurrencyLocale,
  CURRENCY_LOCALES,
} from "../utils/CurrencyUtils";

const BASE_URL = process.env.REACT_APP_BASE_URL;
const GOOGLE_MAPS_KEY = process.env.REACT_APP_GOOGLE_MAPS_KEY;
const NEW_BASE_URL = process.env.REACT_APP_NEW_BASE_URL;

// Strapi Configuration
export const StrapiConfig = {
  url: process.env.REACT_APP_STRAPI_URL || "http://localhost:1337",
  apiToken: process.env.REACT_APP_STRAPI_API_TOKEN || "",
};

// Get locale from environment variable (replaces localStorage concept)
const getLocaleFromEnv = () => {
  return process.env.REACT_APP_LOCALE;
};

// Function to get current locale for API calls
export const getCurrentLocale = () => {
  return getLocaleFromEnv();
};

// Get initial URLs

export const Setting = {
  baseUrl: BASE_URL,
  newBaseUrl: NEW_BASE_URL,
  api: BASE_URL,
  socketURL: BASE_URL,
  GOOLE_MAPS_KEY: GOOGLE_MAPS_KEY,
  FACEBOOK_APP_ID: "",
  GOOGLE_CLIENT_ID:
    "285760163704-28c3c6tm4n688616c059ldl8c08u7ake.apps.googleusercontent.com",
  GOOGLE_CLIENT_SECRET_KEY: "",

  endpoints: {
    me: "api/user/me",
    login: "api/contractor/login",
    signup: "api/user/signup",
    getContractorTermsAndConditions: "api/user/contractor-terms-and-conditions",
    getHomeownerTermsAndConditions: "api/user/homeowner-terms-and-conditions",
    googleData: "auth/google",
    verifyOtp: "api/user/verify-otp",
    resendOtp: "api/user/resend-otp",
    updatepassword: "api/user/update-password",
    updatePasswordOtp: "api/user/update-password-otp",
    updateProfile: "api/user/update-profile",
    accountPassword: "api/admin/reset-password",
    addContractorDetails: "api/contractor/add-contractor-details",
    addPortfolio: "api/contractor/add-portfolio",
    addBillingInfo: "api/contractor/add-billing-info",
    forgotPassword: "api/user/forgot-password",
    contarctorById: "api/contractor", //not used
    deleteportfolio: "api/contractor/delete-portfolio",
    updatesecuritysettings: "api/user/update-security-settings", //not used
    updateUserSetting: "api/user/update-user-settings",
    twoFactorSetting: "api/user/verified-two-factor",
    logoutall: "api/user/logout-all",
    logindeviceslist: "api/user/login-devices-list",
    projectlist: "api/project/project-list",
    projectTypes: "api/project-types",
    expertiseList: "api/expertise/expertise-list",
    milestoneProposalList: "api/project/milestone-project-list",
    singleDeviceLogout: "api/user/other-devices-logout/",
    createproposal: "api/contractor/create-proposal",
    directproposal: "api/contractor/create-direct-proposal",
    updateProposal: "api/contractor/update-direct-proposal",
    createDraftProposal: "api/contractor/create-draft-proposal",
    draftProposalList: "api/project/proposal-drafts-list",
    addFCMToken: "api/user/add-fcm-token",
    logout: "api/user/logout",
    createMilestone: "api/project/create-milestone-project",
    createBudget: "api/project/create-proposal-budget-item", //new not used
    projectDetails: "api/project/my-projects", //new not used
    budgetList: "api/project/list-proposal-budget-item",
    uploadTemplate: "api/project/upload-template", //not used
    deleteTemplate: "api/project/upload-template-delete",
    listcontractorproject: "api/project/list-contractor-project",
    contractorProjects: "api/contractor/projects",
    projectAnalytics: "api/project/analytics-dashboard",
    deleteImage: "api/contractor/delete-image",
    deleteMilestone: "api/project/milestone-proposal-delete",
    deleteBudget: "api/project/delete-budget-item",
    proposalDetails: "/api/project/project-details",
    getProject: "api/project/get-projects",
    deleteSummaryImage: "api/user/delete-image", //not used
    alreadySentProposal: "api/project/already-proposal", //not used
    notificationList: "api/user/notifications-list",
    paymentList: "api/stripe/payment-transaction-list",
    paymentRequest: "api/contractor/add-payment-request", //not used
    milestoneCount: "api/project/project-common-data",
    submitMilestone: "api/project/milestone-delivery",
    updateMilestone: "api/project/single-milestone-update",
    createSingleBudget: "api/project/create-single-proposal-budget-item",
    updateSingleBudget: "api/project/single-proposal-budget-update",
    budgetDelete: "api/project/delete-budget-item",
    milestoneDelete: "api/project/milestone-proposal-delete",
    contractorStates: "api/contractor/stats",
    createUser: "api/contractor/user",
    availableContractors: "/api/admin/available-contractors", //not used
    assignContractors: "api/project/project-submit-contractor", //not used
    approveRejectProject: "api/project/status",
    notes: "api/project/notes",
    projectFiles: "api/project/files",
    packageFiles: "api/files/upload",
    startMilestone: "api/milestone/status",
    deleteProjectImage: "api/user/delete-image",
    getBudgetItem: "api/project/list-proposal-budget-item",
    deleteBudgetItem: "api/project/delete-budget-item",
    changeRequest: {
      // New scope_change_request system (reno-backend).
      list: (projectId) =>
        `api/project/${projectId}/change-requests/scopes?per_page=100`,
      details: (changeRequestId) =>
        `api/project/change-request/${changeRequestId}`,
      approve: (changeRequestId) =>
        `api/project/change-request/approve/${changeRequestId}`,
      reject: (changeRequestId) =>
        `api/project/change-request/reject/${changeRequestId}`,
      // Contractor payouts + BOQ before/after totals (reno-backend, draft preview).
      contractorPayouts: (changeRequestId) =>
        `api/project/change-request/${changeRequestId}/draft/contractor-payouts`,
      // Legacy v2 timeline/design CR endpoints (kept for timeline/design views).
      timelineOrDesignApprove: (changeRequestId) =>
        `api/v2/change-requests/${changeRequestId}/action`,
      timelineDetails: (changeRequestId) =>
        `api/v2/change-requests/${changeRequestId}`,
      preview: (changeRequestId) =>
        `api/v2/change-requests/${changeRequestId}/preview`,
      // Payouts are still served by the legacy Java API.
      payouts: (changeId) =>
        `api/v2/contractors/change-request/${changeId}/payouts`,
    },
    getPaymentScheduleDetails: ({ contractorId, proposalId }) =>
      `api/v2/contractors/${contractorId}/payments?proposalId=${proposalId}`, //not used
    inspections: "api/v2/project/inspections",
    deleteProjectImageById: (imageId) => `api/project/delete-files/${imageId}`,
    inspectionDetails: (inspectionId) =>
      `api/v2/project/inspection/${inspectionId}`,
    newSingleMilestone: "api/v2/project/milestone",
    milestoneDesigns: (projectId) => `api/v2/project/${projectId}/milestone/designs`,
    newBudgetItem: "api/v2/project/budget-item",
    newPaymentGroup: "api/v2/project/payment-group",
    milestoneUpdates: "api/project/milestone-updates",
    milestoneUpdatesSummary: "/api/project/milestone-updates-summary",
    balanceSheetDetails: ({ contractorId }) =>
      `api/v2/contractors/${contractorId}/balanceSheet`,
    uploadDocument: `api/user/document-upload`,
    deleteDocument: `api/user/delete-document`,
    stepsMap: "api/v2/steps/map",
    stepMapping: "api/v2/steps/step-mapping",
    workflowSteps: (workflowName) => `api/v2/steps/workflow/${workflowName}`,
    roles: (page = 0, size = 7, roleType = "CONTRACTOR", includePermissions = true) =>
      `api/roles?page=${page}&size=${size}&roleType=${roleType}&includePermissions=${includePermissions}`,
  },

  JS_Regex: {
    email_Regex:
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    pwd1_Regex: /^.{8,}$/, // /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
    phone_Regex: /^(\+44\s?\d{10}|0044\s?\d{10}|0\s?\d{10})?$/,
    alphabatic_Regex: /^[A-Za-z]+$/,
  },

  page_name: {},
};
